module.exports = __webpack_public_path__ + "img/logo_completo-star.8161aedd.svg";